<!-- @format -->

<template>
	<disabled-text v-if="disabled && showDisabledText" :value="value" />
	<van-field v-else v-model="value" :disabled="disabled" type="textarea" clearable show-word-limit style="padding: 0" />
</template>

<script setup lang="ts">
	import DisabledText from './disabledText.vue';

	interface Props {
		modelValue: string;
		disabled?: boolean;
		showDisabledText?: boolean;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
		showDisabledText: true,
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});
</script>

<style scoped></style>
